import { useState } from 'react'
import { useWishList } from '../../hooks/useWishList'

export default function WishListAction({ catalogId, owned = false, source = 'catalog' }) {
  const wishes = useWishList()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const saved = wishes.rows.some(row => row.catalog_id === catalogId)
  const act = async () => {
    setBusy(true); setError('')
    try { if (saved) await wishes.remove(catalogId); else await wishes.add(catalogId, source) }
    catch (err) { setError(err.message) }
    finally { setBusy(false) }
  }
  return <div><button type="button" className="min-h-11 w-full rounded-lg border border-gold/25 px-2 text-xs text-gold disabled:opacity-40"
    disabled={busy || owned || !catalogId || !wishes.available} aria-pressed={saved} onClick={act}>
    {busy ? 'Saving…' : saved ? 'Remove from wish list' : 'Wish list'}</button>
    {error && <p role="alert" className="text-xs text-red-400">{error}</p>}</div>
}
